<template>
	<div
		v-if="currentStep.step !== 5"
		class="flex"
		:class="!isFirstStep ? 'justify-between' : 'justify-end'"
	>
		<button
			v-if="!isFirstStep"
			type="button"
			class="bg-white py-2 px-4 inline-flex justify-center align-center rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
			@click="$emit('previous')"
		>
			<ArrowCircleLeftIcon class="h-5 w-5 mr-2" aria-hidden="true" />
			Zurück
		</button>
		<button
			type="submit"
			class="ml-3 inline-flex justify-center align-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-accent hover:bg-yellow-600 focus:outline-none"
			@click="$emit('next')"
		>
			{{
				currentStep.step === 4
					? 'Jetzt kostenpflichtig zu obigem Preis bestellen'
					: 'Weiter'
			}}
			<ArrowCircleRightIcon class="h-5 w-5 ml-2" aria-hidden="true" />
		</button>
	</div>
</template>

<script>
import { ArrowCircleLeftIcon, ArrowCircleRightIcon } from '@heroicons/vue/solid'
export default {
	components: {
		ArrowCircleLeftIcon,
		ArrowCircleRightIcon,
	},
	props: {
		isFirstStep: {
			type: Boolean,
			default: false,
		},
		currentStep: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	},
	emits: ['next', 'previous'],
	setup() {
		return {}
	},
}
</script>

<style scoped></style>
